<template>
    <div
        :class="{
            'risk-tolerance-question-dropdown' : true,
            'risk-tolerance-question-dropdown--open' : !isCollapsed,
        }">
        <div
            v-for="(option, optionIndex) in currentOptions"
            :key="option.key"
            class="risk-tolerance-question-dropdown__item-wrapper">
            <radio-item-select-option
                class="risk-tolerance-question-dropdown__item"
                :checked="option.key === selected"
                :title="option.value"
                @click="onItemClick(option.key)" />
            <Icon
                v-if="optionIndex === 0"
                class="risk-tolerance-question-dropdown__button"
                @click.native="toggleCollapse"
                :type="isCollapsed ? 'chevron-down': 'chevron-up'"
                :width="22"
                :height="22" />
        </div>
    </div>
</template>

<script>
import RadioItemSelectOption from '@/components/common/RadioItemSelectOption';
import { RiskToleranceAnswer } from '@/api/enums';

export default {
    name: 'RiskToleranceQuestionDropdown',
    components: {
        RadioItemSelectOption,
    },
    props: {
        isCollapsed: {
            type: Boolean,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        selected: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        currentOptions () {
            if (this.isCollapsed) {
                if (this.selected && this.selected !== RiskToleranceAnswer.NOT_ANSWERED) {
                    return [this.options.find(option => option.key === this.selected)];
                } else {
                    return [this.options[0]];
                }
            }
            return this.options;
        },
    },
    methods: {
        toggleCollapse () {
            this.$emit('toggleCollapse');
        },
        onItemClick (key) {
            this.isCollapsed ? this.toggleCollapse() : this.$emit('onSelect', key);
        },
    },
};
</script>

<style scoped lang="scss">
  .risk-tolerance-question-dropdown {
    background: $mb-grey-12;
    width: 100%;
    padding: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

    &--open {
      padding: 10px 0;
    }

    ::v-deep .radio-item {
      min-height: 40px;
    }
  }

  .risk-tolerance-question-dropdown__button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 10px;
  }

  .risk-tolerance-question-dropdown__item {
    padding: 5px 40px 5px 0;
  }

  .risk-tolerance-question-dropdown__item-wrapper {
    position: relative;
  }

  .radio-item-select__list-text {
      @include bold();
      padding-left: 10px;
      padding-bottom: 20px;
      line-height: 18px;
  }

  ::v-deep .radio-item {
    height: auto;
    min-height: 35px;
  }
</style>
